import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import { hideConfirm } from '../../reducer/confirmSlice'

const Confirm = () => {
	const dispatch = useDispatch()
	const { value, msg, func, btnText } = useSelector(state => state.confirm)

	const handleCancel = () => dispatch(hideConfirm())
	const handleConfirm = () => {
		func?.()
		dispatch(hideConfirm())
	}

	return (
		<Modal
			show={value}
			centered
			size="sm"
			className="custom-modal"
			backdrop="static"
			onHide={handleCancel}
		>
			<Modal.Body className="body">{msg}</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={handleCancel}>
					취소
				</Button>
				<Button variant="primary" className="confirm-btn" onClick={handleConfirm}>
					{btnText}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default Confirm